<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box no-display" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Get Student Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined persistent-hint
                        hint="Please select academic year" @click="show = false"  />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" :items="standard_list"
                        item-text="name" item-value="id" label="Select Standard" outlined persistent-hint
                        hint="Please select standard"  @change="sel_div_data=null"/>
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_div_data" :items="division_list" 
                        item-text="name" item-value="id" label="Select Division" outlined persistent-hint
                        hint="Please select division" @change="getStud()"/>
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="sel_std_data && sel_div_data">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete v-model="registration_no" rounded color="#0F2027" :items="stud_list"
                        label="Select Student" item-text="name" return-object outlined dense @click="show = false"
                        persistent-hint hint="Please select Student" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && registration_no">
                    <v-checkbox class="pl-6 pt-4" v-model="show_hide_percentage" label="Show Parent View"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="4" md="4" v-if="sel_ay_data && registration_no">
                    <v-btn class="mt-6 button" :loading="fecth_gen_btn_loader" @click="getreport_3()">View Marksheet
                    </v-btn>
                    <v-btn class="mt-6 button" :loading="fecth_gen_btn_loader" @click="getreport_2()">Print Marksheet
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed


    import "jspdf-autotable";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                default_value: [],
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                overlay: false,
                selected: [],
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                fetch_loader: false,
                show: false,
                stud_list: [],
                division_list:[],
                standard_list:[],
                sel_std_data:"",
                sel_div_data:"",
                registration_no: null,
                awspath: "",
                assessment_detail_list: [],
                asd: null,
                role: null,
                radios: null,
                show_hide_percentage:false,
            };
        },
        watch: {
            sem() {
                this.registration_no = null;
            },
        },
        methods: {
           

            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            putnull3() {
                this.show = false;
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            // async getreport(){
            //     localStorage.setItem("setay", this.sel_ay_data.ay_id);
            //     localStorage.setItem("setreg_no", this.registration_no.registration_number);
            //     let routeData = this.$router.resolve({
            //         name: "wws-icsc-annual-print",
            //     });
            //     window.open(routeData.href, "_blank");
            // },
            async getreport_3(){
                localStorage.setItem("setay", this.sel_ay_data.ay_id);
                localStorage.setItem("setreg_no", this.registration_no.registration_number);
                localStorage.setItem("show_hide_percentage", this.show_hide_percentage);
                
                if (
                this.registration_no.standard == "I" ||
                this.registration_no.standard == "II" ||
                this.registration_no.standard == "III"
                )
                {
                    let routeData = this.$router.resolve({
                        name: "wws-icsc-annual-view-I-III",
                    });
                    window.open(routeData.href, "_blank");
                }
                else{
                    let routeData = this.$router.resolve({
                        name: "wws-icsc-annual-view",
                    });
                    window.open(routeData.href, "_blank");
                }
            },
            async getreport_2(){
                localStorage.setItem("setay", this.sel_ay_data.ay_id);
                localStorage.setItem("setreg_no", this.registration_no.registration_number);
                localStorage.setItem("show_hide_percentage", this.show_hide_percentage);

                if (
                this.registration_no.standard == "I" ||
                this.registration_no.standard == "II" ||
                this.registration_no.standard == "III"
                )
                {
                    let routeData = this.$router.resolve({
                        name: "wws-icsc-annual-print-I-III",
                    });
                    window.open(routeData.href, "_blank");
                }
                else{
                    let routeData = this.$router.resolve({
                    name: "wws-icsc-annual-print-2",
                    });
                    window.open(routeData.href, "_blank");
                }
               
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getStud() {
                this.role = sessionStorage.getItem("para_role");
                const data = {
                    ay:this.sel_ay_data.ay_id,
                    std: this.sel_std_data,
                    div: this.sel_div_data,
                    role: this.role,
                };
                axios
                    .post("/admission/getAllStudents_for_marksheet", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.stud_list = res.data.stud_list;
                        } else if(res.data.code == "NA"){
                            this.showSnackbar("#b71c1c", res.data.msg);
                        }
                        else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.comp_load = false;
                    });
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.standard_list = res.data.standard_list;
                        this.division_list = res.data.division_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
            this.awspath = localStorage.getItem("awspath");
        },
    };
</script>
<style scoped>
    .text_report {
        border: 3px solid black;
        margin: 1rem !important;
    }
    thead {
        font-weight: bold !important;
    }
    th {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border: 1px solid black;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border: 1px solid black;
        font-size: small;
    }
    td {
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
    @media print {
        .card {
            border: none !important;
            font-size: large !important;
        }
        .pagebreak {
            page-break-before: always;
        }
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        img {
            width: 100% !important;
        }
        body,
        tr,
        th,
        td {
            font-size: large !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            size: 15.5in 15.5in;
        }
        thead {
            font-weight: bold !important;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }
    ol.s {
        list-style-type: inherit;
    }
</style>
